import React from "react";
import '../style.css';
import { FormattedMessage } from 'react-intl';

function TodoItem(props) {

    return (
        <li className={`${props.completed && 'task-checked'}`} >
        <div className="checkbox">
        <div className="check">
            <input type="checkbox" name="task_00" onClick={(props.onComplete)} onLoad={verify(props.text, props.completed)}
            />
            <div className="ripple-container">
            <div className="check-off"></div>
            <div className="check-on"><i className="fa fa-check"></i></div>
            <div className="check-ripple"></div>
            </div>
        </div>
        <div className="label">
        <i className="fa fa-trash" onClick={props.onDelete}></i>
            <mark>{props.text}</mark>
            <br/>
            <time>{props.date}</time>
        </div>
        </div>
        <span className="task-msg"><FormattedMessage id="checkmessage.span" defaultMessage="Well done!"/></span>
        </li>
      );
}

function verify(txt, c) {
    let li = document.getElementsByTagName("li");
    for (let i = 0; i < li.length; i++) {
        if(li[i].innerText.includes(txt) === true && c === true) {
            li[i].children[0].children[0].children[0].checked = true;
        }  
    }
}

export { TodoItem };